module.exports = __webpack_public_path__ + "static/media/register.727c4e01.svg";